'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".ReturnReasonsComments-module_textarea__eIe-6{display:flex;min-height:200px;width:100%}.ReturnReasonsComments-module_commentWrapper__9HRpY{display:flex;flex-direction:column;gap:8px;width:100%}";
var styles = {"textarea":"ReturnReasonsComments-module_textarea__eIe-6","commentWrapper":"ReturnReasonsComments-module_commentWrapper__9HRpY"};
styleInject["default"](css_248z, '300caea5-c222-4c2a-9fef-cee19b2f6dbb');

exports["default"] = styles;
